import Model from "../Model";

class Groupcompanydetails extends Model{

    buildUrl ({ param }) {
        return ['groupview/details', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Groupcompanydetails;